import { CrmDeviceMisosPostRequestDto } from './crm-device-misos-post.request.dto';

export type CrmDeviceMisosPatchRequestDto = CrmDeviceMisosPostRequestDto;
